export default __webpack_public_path__ + "static/media/BR.9798702d.ico";